<template>
  <div class="navbar relative bg-white">
    <div class="max-w-7xl mx-auto h-full px-4">
      <div class="flex justify-between items-center h-full">
        <div class="lg:w-0 lg:flex-1">
          <a>
            <span class="sr-only">DDHQ Election Results</span>
            <img src="@/assets/img/ddhq_logo.png" alt="">
          </a>
        </div>
        <a class="button" @click="logout" v-if="$auth.isAuthenticated.value">
          Logout
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$auth.logout()
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.navbar {
  height: 50px;
  z-index: 1;
  border-bottom: 1px solid #eee;
}

img {
  height: 18px;
  width: auto;
}
</style>
